import { all, fork } from "redux-saga/effects";
import homeSaga from "../module/home/saga";

export default function* rootSaga() {
  yield all([fork(homeSaga)]);
}
